import classNames from 'classnames';

import Flags from '../../assets/flags';

import styles from './Country.module.scss';

type Props = {
  id: string;
  name?: string;
  phoneCode?: string;
  isSelected?: boolean;
};

const Country = ({ id, name, phoneCode, isSelected }: Props) => {
  const countryId = id.toUpperCase();
  const flag = Flags[countryId];

  return (
    <div className={classNames(styles.country, { [styles.countryColor]: true })}>
      <img className={styles.flag} src={flag} alt="flag country" />

      <div className={styles.innerContent}>
        {phoneCode && <p>{`(${phoneCode})`}</p>}
        {name && <p className={classNames([styles.name, { [styles.selected]: isSelected }])}>{name}</p>}
      </div>
    </div>
  );
};

export default Country;
